import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import App from "./app.jsx";
import "./assets/styles/global.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
